export default __webpack_public_path__ + "static/media/waiting.7deb0537.svg";